import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import TitleH1 from "../components/titleH1"
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import DivWhite from "../components/divWhite"
import Table from "../components/table"
import Navbar from "../components/navbar"
import Menu from "../components/menu"

const Expired = props => {
    const [data, setData] = useState([])
    const history = useHistory()

    useEffect(() => {
        const fetchLicences = async () => {
            const res = await props.actions.licence.getAllLicences()
            setData(res.filter(licence => new Date(licence.validite) < new Date(`${new Date().getFullYear()}-01-01`)))
        }
        fetchLicences()
    }, [props.actions.licence])

    return (
        <>
            <Navbar/>
            <Menu/>
            <TitleH1 content="Les licences expirées"/>
            {
                data.length > 0 ?
                    <>
                        <DivWhite content={
                            <Table content={
                                <>
                                    <thead>
                                    <tr>
                                        <td>Prénom & nom</td>
                                        <td>Numéro licence</td>
                                        <td>Catégorie</td>
                                        <td>Validité</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        data.map(licence => {
                                            return (
                                                <tr key={licence._id}>
                                                    <td onClick={() => history.push(`/licence/${licence._id}`)}>
                                                        {licence.prenom} {licence.nom}
                                                    </td>
                                                    <td>{licence.numeroLicence}</td>
                                                    <td>{licence.categorie}</td>
                                                    <td>{licence.validite}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </>
                            } width="100%"/>
                        } width="100%"
                        />
                    </>
                    : null
            }
        </>
    )
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Expired)
